import { extend } from 'vee-validate'
import { required, email, image } from 'vee-validate/dist/rules'
import { i18n } from './plugins'
import { isBefore, isAfter, isValid, parseISO, isToday } from 'date-fns'
import { formatDate } from '@utils/date'
import GLOBAL_VALUES from '@utils/global-values.js'

extend(GLOBAL_VALUES.INPUT_RULES.REQUIRED, {
    ...required,
    message: i18n.t('Errors.requiredField'),
})

extend(GLOBAL_VALUES.INPUT_RULES.IMAGE, {
    ...image,
    message: i18n.t('Errors.notImage'),
})

extend(GLOBAL_VALUES.INPUT_RULES.EMAIL, {
    ...email,
    message: i18n.t('Errors.emailFormat'),
})

// o usuário não pode selecionar uma data superior a do dia atual
extend(GLOBAL_VALUES.INPUT_RULES.VALID_DATE, (value) => {
    const usFormatDate = formatDate(value)
    const isInvalidDate = isAfter(parseISO(usFormatDate), new Date())
    if (!isValid(parseISO(usFormatDate)) || isInvalidDate) {
        return i18n.t('Errors.invalidDate')
    }
    return true
})

// data em formato válido
extend(GLOBAL_VALUES.INPUT_RULES.DATE_FORMAT, (value) => {
    const usFormatDate = formatDate(value)
    if (!isValid(parseISO(usFormatDate))) {
        return i18n.t('Errors.invalidDate')
    }
    return true
})

// o usuário tem que selecionar uma data a partir da atual
extend(GLOBAL_VALUES.INPUT_RULES.DATE_FROM_TODAY, (value) => {
    const usFormatDate = parseISO(formatDate(value))
    const isInvalidDate =
        !isToday(usFormatDate) && isBefore(usFormatDate, new Date())
    if (!isValid(usFormatDate) || isInvalidDate) {
        return i18n.t('Errors.dateFromToday')
    }
    return true
})
extend(GLOBAL_VALUES.INPUT_RULES.VALID_HOUR, (value) => {
    const validRegex = /\b([01][0-9]|2[0-3]):([0-5][0-9])\b/gi.test(value)
    if (!validRegex) return i18n.t('Errors.invalidHour')
    return true
})
extend(GLOBAL_VALUES.INPUT_RULES.POSITIVE_NUMBER, (value) => {
    if (value <= 0) return i18n.t('Errors.typePositiveNumber')
    return true
})
extend(GLOBAL_VALUES.INPUT_RULES.ONLY_ACTIVE, (value) => {
    // eslint-disable-next-line no-prototype-builtins
    if (!value.hasOwnProperty('status') || value.status) return true
    return i18n.t('Errors.inactiveUser')
})
extend(GLOBAL_VALUES.INPUT_RULES.VALID_CPF, (value) => {
    if (value.toString().length < 14) return i18n.t('Errors.invalidCPF')
    return true
})
extend(GLOBAL_VALUES.INPUT_RULES.VALID_CNPJ, (value) => {
    if (value.toString().length < 18) return i18n.t('Errors.invalidCNPJ')
    return true
})
extend(GLOBAL_VALUES.INPUT_RULES.RACIONAL_VALUE, (value) => {
    if (parseInt(value) <= 0) return i18n.t('Errors.minValue')
    return true
})
extend(GLOBAL_VALUES.INPUT_RULES.SPECIAL_CHARACTERS, (value) => {
    const specialCharactersBlocker = /[~`!@#$%^&()={}[\]:;,.<>+?]/
    if (specialCharactersBlocker.test(value))
        return i18n.t('Errors.specialCharacter')
    return true
})
